/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyDataList {
    getFixupPrototypeFunction() { return PolicyDataList.fixupPrototype; }

    static newInstance(model: Partial<PolicyDataList>): PolicyDataList {
        let obj = Object.assign(new PolicyDataList(), model);
        PolicyDataList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyDataList>): PolicyDataList {
        if (!model) return null;
        return PolicyDataList.newInstance(<PolicyDataList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyDataList) {
        if (!obj) return;

        models.PolicyDataList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyDataList): boolean {
        Object.setPrototypeOf(obj, PolicyDataList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Policy Id is unique identifier of a policy
     */
    policy_id: string;

    /**
     * Policy Name is unique can allow only
     */
    name: string;

    /**
     * Display name of policy
     */
    display_name: string;

    /**
     * Unique URI for policy
     */
    uri: string;

    /**
     * A brief explanation of the policy.
     */
    description: string;

    /**
     * Indicates whether the policy is active or inactive.
     */
    status: string;

    /**
     * Displays the service associated with the policy, for example, AWS, AzureRM, Openstack., etc
     */
    services: Array<string>;

    /**
     * Engine type of policy where it will execute
     */
    engine_type: string;

    /**
     * Type of the policy.
     */
    policy_type: string;

    /**
     * Content type of policy (Git or File)
     */
    content_type: string;

    /**
     * Classification of policy
     */
    classification: models.PolicyClassification;

    /**
     * Sub classification of policy
     */
    sub_classification: string;

    /**
     * Category of policy
     */
    category: string;

    /**
     * Resource type of policy
     */
    resource_type: string;

    service_resources: Array<string>;

    /**
     * The scope of the policy. Account scope: All users under that account will have access to view and execute. Only Account admins can update or delete the policies. Tenant scope: Users with access to the specific tenant will have access to policies and can describe or execute policies. Tenant admins can only update or delete. Private scope: Only the user who created the policy will have access.
     */
    scope: string;

    /**
     * Severity of policy
     */
    severity: models.PolicySeverityRisk;

    /**
     * Parameters associated with the policy as JSON string.
     */
    parameters: string;

}
